import React from "react";
import cx from "clsx";
import PropTypes from "prop-types";
import { UsersIcon } from "../../../../assets/Icons/UsersIcon";
import "./CalendarEvent.styles.scss";
import styles from "./CalendarEvent.module.scss";
import GFEIconV2 from "../../../../assets/Icons/GFEIconV2";

function CalendarEvent({
  event: { confirmed_status, isAdditionalProvider, gfeOnFile, gfeExpired },
}) {
  const gfeIconColor = () => {
    if (gfeOnFile) {
      return "#03bf62";
    } else {
      if (gfeExpired) {
        return "#FF0000";
      }
      return "#bcbcbc";
    }
  };

  return (
    <div className={cx("appointmentConfirmIconWrapper", styles.iconsWrapper)}>
      {confirmed_status === "Confirmed" && (
        <span className="confirmedIcon">
          <i className="fa fa-check-circle" />
        </span>
      )}
      {gfeOnFile !== null && gfeOnFile !== undefined && (
        <div className={styles.gfeWrapper}>
          <GFEIconV2 width="26px" height="16px" color={gfeIconColor()} />
        </div>
      )}
      {isAdditionalProvider && (
        <div className="usersIcon">
          <UsersIcon />
        </div>
      )}
    </div>
  );
}

CalendarEvent.propTypes = {
  confirmed_status: PropTypes.string,
};

CalendarEvent.defaultProps = {
  confirmed_status: "Not Confirmed",
};

export default CalendarEvent;
